import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskKindEnum } from '@zaoblako/shared/modules/task/enum/task-kind.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link TaskKindEnum} enumeration values */
export const TaskKindEnumI18n: EnumI18nInterface<TaskKindEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaskKindEnum.PAYMENT_TO_SUPPLIER]: 'Оплата поставщику',
    [TaskKindEnum.PAYMENT_TO_SELF_EMPLOYED]: 'Оплата самозанятому',
    [TaskKindEnum.PAYMENT_OF_TAXES]: 'Уплата налогов',
  },
  [I18nLocalesEnum.EN_US]: {
    [TaskKindEnum.PAYMENT_TO_SUPPLIER]: 'Payment to supplier',
    [TaskKindEnum.PAYMENT_TO_SELF_EMPLOYED]: 'Payment to the self-employed',
    [TaskKindEnum.PAYMENT_OF_TAXES]: 'Payment of taxes',
  },
};
